import React, { forwardRef } from 'react';

import { useStore } from '@spazious/dollhouse-store';
import { ToggleButton, ToggleButtonProps } from '@spazious/dollhouse-uikit';

export interface ToggleButtonLabelProps extends ToggleButtonProps {
  label?: React.ReactNode;
}

/** This component controls the label displaying based on the store settings */
export const ToggleButtonLabel = forwardRef<HTMLButtonElement, ToggleButtonLabelProps>(
  ({ label, children, ...restProps }, forwardedRef) => {
    const showButtonTitles = useStore(({ settings }) => settings.showButtonTitles);

    return (
      <ToggleButton ref={forwardedRef} {...restProps}>
        {children}
        {showButtonTitles && label}
      </ToggleButton>
    );
  }
);
